import { Controller } from "@hotwired/stimulus"

// Simple video protection - no custom controls
export default class extends Controller {
  connect() {
    console.log("🎥 Basic Video Protection: Activated")
    
    // Simple right-click protection
    this.element.addEventListener('contextmenu', (event) => {
      event.preventDefault()
      console.log("Right-click blocked")
      return false
    })
    
    this.element.style.userSelect = 'none'
  }
}
